import { ChartDataType } from "../common/Chart/type";
import { ButtonGroupValueType } from "../common/Buttongroup/type";

export type ChartHistoryProps = {
  buttonGroupValue: ButtonGroupValueType[];
  data: ChartDataType[] | undefined;
  onSelected: (selectedValue: string) => void;
  isLoading?: boolean;
};

export enum ButtonGroupValue {
  ONE_WEEK = "past1Week",
  ONE_MONTH = "past1Month",
  THREE_MONTH = "past3Months",
}
